export default __webpack_public_path__ + "static/03-3328879e183af573e7ccd055d755b445.gif";